import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import { Button } from 'helpers/components';

const Access = ({ handleScroll }) => {
  return (
    <AccessSection>
      <Container>
        <AccessTitle>{useText('access__title', true)}</AccessTitle>
        <AccessList>
          {[1, 2, 3, 4, 5].map((id) => (
            <AccessListItem key={id}>
              <AccessListImage>
                {useImg(`icon_${id}.svg`, `icon_${id}`)}
              </AccessListImage>
              <AccessListText>
                {useText(`access__text_${id}`, true)}
              </AccessListText>
            </AccessListItem>
          ))}
        </AccessList>
        <Button buttonCss={buttonCss} clickHandler={handleScroll}>
          {useText('access__btn', true)}
        </Button>
      </Container>
    </AccessSection>
  );
};

const AccessSection = styled.section`
  position: relative;

  @media ${DESKTOP} {
    padding: 85px 0 45px;
  }

  @media ${TABLET} {
    padding: 310px 0 25px;
  }

  @media ${MOBILE} {
    padding: 300px 0 22px;
  }

  &:before {
    content: '';
    display: block;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('access.png')};
    width: 675px;
    height: 465px;
    position: absolute;
    top: 163px;
    left: calc(50% - 820px);

    @media ${TABLET} {
      top: 0;
      left: calc(50% - 448px);
      width: 544px;
      height: 375px;
    }

    @media ${MOBILE} {
      top: 32px;
      left: calc(50% - 144px);
      width: 363px;
      height: 250px;
      transform: scaleX(-1);
    }
  }
`;

const AccessTitle = styled.div`
  font-weight: 900;
  font-size: 46px;
  line-height: 126.1%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #000000;
  margin-bottom: 60px;

  @media ${TABLET} {
    font-size: 40px;
    text-align: right;
    margin-bottom: 40px;
  }

  @media ${MOBILE} {
    font-size: 26px;
    margin-bottom: 30px;
  }
`;

const AccessList = styled.div`
  position: relative;
  margin-bottom: 50px;
`;

const AccessListItem = styled.div`
  display: flex;
  align-items: center;

  @media ${DESKTOP} {
    &:nth-child(2),
    &:nth-child(3) {
      max-width: 770px;
    }

    &:nth-child(1),
    &:nth-child(4),
    &:nth-child(5) {
      max-width: 835px;
    }
  }

  &:not(:last-child) {
    margin-bottom: 42px;

    @media ${MOBILE} {
      margin-bottom: 35px;
    }
  }
`;

const AccessListImage = styled.div`
  margin-left: 27px;
  width: 70px;
  flex-shrink: 0;

  @media ${MOBILE} {
    margin-left: 17px;
  }
`;

const AccessListText = styled.div`
  font-size: 20px;
  line-height: 133.1%;
  text-align: right;
  letter-spacing: 0.02em;
  color: #000000;

  @media ${MOBILE} {
    font-size: 18px;
    line-height: 133.1%;
  }
`;

const buttonCss = css`
  width: 100%;
  max-width: 337px;
  min-height: 73px;
  background: linear-gradient(
    0deg,
    #ac7524 3.88%,
    #c18d2f 11.96%,
    #f8cb49 28.97%,
    #ffd34d 31.1%,
    #fee565 58.42%,
    #fded6f 68.35%,
    #e38700 99.88%
  );
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #191104;
  margin: 0 auto;

  @media ${TABLET} {
    &:active {
      transform: scale(1.06);
    }
  }

  @media ${MOBILE} {
    &:active {
      transform: scale(1.06);
    }
  }
`;

Access.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default Access;
